import { Box, Button, Divider, Stack, Typography } from "@mui/joy";
import FilterReservation from "./FilterReservation";
import FilterWineGlass from "./FilterWineGlass";
import { COLOR_PRIMARY } from "../../../utils/styles";
import FilterPrice from "./FilterPrice";
import FilterOpenNow from "./FilterOpenNow";
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

function FilterOptions() {
  return (
    <Box
      sx={{
        paddingTop: "50px",
        paddingLeft: "40px",
        paddingRight: "40px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        textAlign: "left",
        gap: "25px",
      }}
    >
      <Typography
        level="h4"
        sx={{
          "&::selection": {
            backgroundColor: COLOR_PRIMARY,
          },
        }}
      >
        Filters
      </Typography>
      <Stack spacing={1}>
        <Typography fontWeight={700}>Corkage</Typography>
        <FilterPrice />
      </Stack>
      <Divider />
      <Stack spacing={1}>
        <Typography fontWeight={700}>Logistics</Typography>
        <FilterReservation />
        <FilterWineGlass />
        <FilterOpenNow />
      </Stack>
      <Button
        variant="outlined"
        color="neutral"
        endDecorator={<ChatBubbleOutlineIcon />}
        onClick={() => window.open("https://forms.gle/JAfazRrKb5Eev1ZA9")}
      >Give us feedback!</Button>
    </Box>
  );
}

export default FilterOptions;
